import { gql } from '@apollo/client';

export default class AppReleaseSubscription {
    static APP_RELEASE_ACTIVATED = gql`
        subscription appReleaseActivated {
            appReleaseActivated {
                appReleaseId
                version
                title
                type
                content
                releaseDate
                active
            }
        }
    `;
}
